/** Hardcoded link preview title, description, and image. */
export const SHARE_SITE_URL = 'https://uvunion.co.ke/';
export const SHARE_LINK_TITLE = "Ursula & Vitalis' Traditional Marriage";
export const SHARE_LINK_DESCRIPTION =
  "Join us as we celebrate Ursula & Vitalis' Traditional Marriage.";
export const SHARE_LINK_IMAGE = `${SHARE_SITE_URL}og-share.jpg`;

export const SHARE_LINK_DEFAULTS = {
  share_link_title: SHARE_LINK_TITLE,
  share_link_description: SHARE_LINK_DESCRIPTION,
  share_link_image: SHARE_LINK_IMAGE,
};
